import { useCallback, useReducer, useRef } from "react"

export function useToggling() {
  const togglingRef = useRef<Set<string>>(new Set)
  const [, forceRender] = useReducer(x => !x, false)

  const isToggling = useCallback((id: string) => {
    return togglingRef.current.has(id)
  }, [])

  const withToggling = useCallback(async (id: string, fn: () => Promise<void>) => {
    if (togglingRef.current.has(id)) return

    togglingRef.current.add(id)
    forceRender()

    try {
      await fn()
    } finally {
      togglingRef.current.delete(id)
      forceRender()
    }
  }, [])

  return { isToggling, withToggling }
}